import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { noop } from 'shell/utils/noop';
import { RegisterCertification } from 'shell/models/register-certification';
import Form, {
  RegisterCertificationForm,
} from 'front-office/components/register-certification/form';
import { RegisterCertificationCrumbs } from 'front-office/constants/register-certification-crumbs';
import { transformRegisterCertification } from 'front-office/components/register-certification/utils/transform-register-certification';

const RegisterCertificationDetail = (): React.ReactElement => {
  const params = useParams();

  const [registerCertification] = useHttpFetch<
    HttpResponse<RegisterCertification>,
    RegisterCertificationForm
  >(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-registro/${params.id}/ente/${params.institution}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformRegisterCertification,
    }
  );

  const navigate = useNavigate();

  return (
    <Fragment>
      <Breadcrumbs items={[...RegisterCertificationCrumbs, { name: 'Dettaglio Registro' }]} />
      <Form
        onOk={noop}
        onCancel={() => {
          navigate('/sportello/ricerca-registro');
        }}
        title="Dettaglio Registro"
        initialValues={registerCertification.data as RegisterCertificationForm}
        disabled
      />
    </Fragment>
  );
};

RegisterCertificationDetail.displayName = 'Register certification detail page component';

export default RegisterCertificationDetail;
